import axios from "axios";

// Get base URL from environment
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
// Create Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach Bearer token automatically
api.interceptors.request.use(
  (config) => {
    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      config.headers.delete("Content-Type");
    }
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle global errors
api.interceptors.response.use(
  (response) => {
    // If the response contains profile/image URLs that start with "/", prepend base backend URL
    if (response.data && typeof response.data === "object") {
      prependBaseUrl(response.data);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Stale or invalid token — clear session and redirect to login
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// Helper function to prepend BASE backend URL to relative paths
function prependBaseUrl(obj) {
  for (const key in obj) {
    if (typeof obj[key] === "string" && obj[key].startsWith("/")) {
      obj[key] = BASE_URL.replace("/api", "") + obj[key];
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      prependBaseUrl(obj[key]);
    }
  }
}

export default api;
